<template>
    <!-- 通知公告 -->
    <div class="inside_pages_right_top">
        <ul>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/inbox'}"  @click="$Common.pageJump('/inbox',3)">收件箱</li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/send_mailbox'}" @click="$Common.pageJump('/send_mailbox',3)">发件箱</li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/drafts'}" @click="$Common.pageJump('/drafts',3)">草稿箱</li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/improving_notice'}" @click="$Common.pageJump('/improving_notice',3)">整改通知</li>
        </ul>
    </div>
</template>

<script>
export default {
    name:'NoticeTop',
    components: {},
    props: {},
    data() {
        return {
        };
    },
    watch: {
    },
    computed: {
    },
    methods: {
       
    },
    created() {
    },
    mounted() {
    },
};
</script>
<style scoped>
@import '/css/base.css';
</style>